import { redirect } from '@tanstack/react-router';
import type { Permissoes, TipoUsuario } from '../api';
import { buscarPermissoes, buscarSessao } from '../auth';

export async function permissaoGuard(permissao: Permissoes) {
  const permissoes = await buscarPermissoes();

  if (permissoes.includes(permissao)) {
    return;
  }

  throw redirect({
    to: '/sem-permissao',
  });
}

export async function tipoUsuarioGuard(tipoUsuario: TipoUsuario) {
  const usuario = await buscarSessao();

  if (usuario?.tipo === tipoUsuario) {
    return;
  }

  throw redirect({
    to: '/sem-permissao',
  });
}
